(function () {
  const DATA = (window.TRADE_SHOWS || []);
  const $ = (id) => document.getElementById(id);

  const els = {
    q: $('pd_q'),
    fIndustry: $('pd_fIndustry'),
    fMonth: $('pd_fMonth'),
    fCity: $('pd_fCity'),
    fState: $('pd_fState'),
    fAtt: $('pd_fAttendees'),
    applyBtn: $('pd_applyBtn'),
    resetBtn: $('pd_resetBtn'),
    resetBtnMobile: $('pd_resetBtnMobile'),
    pageSize: $('pd_pageSize'),
    prevBtn: $('pd_prevBtn'),
    nextBtn: $('pd_nextBtn'),
    prevBtn2: $('pd_prevBtn2'),
    nextBtn2: $('pd_nextBtn2'),
    matchCount: $('pd_matchCount'),
    countMobile: $('pd_countMobile'),
    showingCount: $('pd_showingCount'),
    tbody: $('pd_rows'),
    empty: $('pd_emptyState'),
    tableArea: $('pd_tableArea'),
    openFiltersBtn: $('pd_openFiltersBtn'),
    closeFiltersBtn: $('pd_closeFiltersBtn'),
    overlay: $('pd_overlay'),
    sheet: $('pd_sheet'),
    mobileFiltersHost: $('pd_mobileFiltersHost'),
    totalCount: $('pd_totalCount'),
  };

  const required = ['tbody','tableArea','empty','pageSize','q','fIndustry','fMonth','fCity','fState','fAtt'];
  for (const key of required) {
    if (!els[key]) {
      console.error('[TradeShows] Missing element:', key);
      return;
    }
  }

  const state = {
    q: '',
    industry: '',
    month: '',
    city: '',
    st: '',
    attendees: '',
    page: 1,
    pageSize: parseInt(els.pageSize.value, 10) || 25,
    filteredIdx: [],
  };

  function esc(s) {
    return String(s ?? '')
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;").replace(/'/g, "&#039;");
  }

  function titleCase(str) {
    return String(str || '')
      .split(' ')
      .map(w => w ? (w[0].toUpperCase() + w.slice(1).toLowerCase()) : w)
      .join(' ');
  }

  function uniqSorted(arr) {
    const set = new Set(arr.filter(Boolean).map(s => String(s).trim()).filter(Boolean));
    return Array.from(set).sort((a, b) => a.localeCompare(b));
  }

  function fillSelect(selectEl, values, allLabel, transform) {
    selectEl.innerHTML = '';
    const optAll = document.createElement('option');
    optAll.value = '';
    optAll.textContent = allLabel;
    selectEl.appendChild(optAll);

    values.forEach(v => {
      const o = document.createElement('option');
      o.value = v;
      o.textContent = transform ? transform(v) : v;
      selectEl.appendChild(o);
    });
  }

  function initDropdowns() {
    const industries = uniqSorted(DATA.map(d => d.industry));
    const months = uniqSorted(DATA.map(d => d.month));
    const cities = uniqSorted(DATA.map(d => d.city));
    const states = uniqSorted(DATA.map(d => d.state));

    fillSelect(els.fIndustry, industries, 'All industries', titleCase);
    fillSelect(els.fMonth, months, 'All months', titleCase);
    fillSelect(els.fCity, cities, 'All cities', titleCase);
    fillSelect(els.fState, states, 'All states', (s) => String(s || '').toUpperCase());
  }

  function attendeesMatch(n, slab) {
    if (!slab) return true;
    const num = Number(n);
    if (!Number.isFinite(num)) return false;

    switch (slab) {
      case 'lt500': return num < 500;
      case '500_1000': return num >= 500 && num <= 1000;
      case '1000_5000': return num >= 1000 && num <= 5000;
      case '5000_20000': return num >= 5000 && num <= 20000;
      case '20000_50000': return num >= 20000 && num <= 50000;
      case '50000_100000': return num >= 50000 && num <= 100000;
      case 'gt100000': return num > 100000;
      default: return true;
    }
  }

  function readControlsIntoState() {
    state.q = (els.q.value || '').trim().toLowerCase();
    state.industry = (els.fIndustry.value || '').trim().toLowerCase();
    state.month = (els.fMonth.value || '').trim().toLowerCase();
    state.city = (els.fCity.value || '').trim().toLowerCase();
    state.st = (els.fState.value || '').trim().toLowerCase();
    state.attendees = (els.fAtt.value || '').trim();
  }

  function computeFiltered() {
    const q = state.q;
    const industry = state.industry;
    const month = state.month;
    const city = state.city;
    const st = state.st;
    const att = state.attendees;

    const idx = [];
    for (let i = 0; i < DATA.length; i++) {
      const d = DATA[i];
      if (industry && String(d.industry || '').toLowerCase() !== industry) continue;
      if (month && String(d.month || '').toLowerCase() !== month) continue;
      if (city && String(d.city || '').toLowerCase() !== city) continue;
      if (st && String(d.state || '').toLowerCase() !== st) continue;
      if (!attendeesMatch(d.attendeesNum, att)) continue;
      if (q && !String(d.search || '').includes(q)) continue;
      idx.push(i);
    }
    state.filteredIdx = idx;
  }

  function setPagerDisabled(btn, isDisabled) {
    if (!btn) return;
    btn.disabled = isDisabled;
    btn.style.opacity = isDisabled ? 0.5 : 1;
  }

  function renderPage() {
    const total = state.filteredIdx.length;
    const pageSize = state.pageSize;
    const totalPages = Math.max(1, Math.ceil(total / pageSize));
    if (state.page > totalPages) state.page = totalPages;
    if (state.page < 1) state.page = 1;

    const start = (state.page - 1) * pageSize;
    const end = Math.min(total, start + pageSize);

    let html = '';
    for (let k = start; k < end; k++) {
      const d = DATA[state.filteredIdx[k]];

      const url = (d.detailsUrl || '').trim();
      const seoText = (d.detailsText || 'Explore details').trim();

      const href = url ? url : 'javascript:void(0)';
      const rel = url ? 'noopener noreferrer' : '';
      const target = url ? '_blank' : '';
      const ariaDisabled = url ? '' : 'aria-disabled="true"';

      html += `
        <tr>
          <td data-label="Show Name"><div class="pd-cellmain">${esc(d.show)}</div></td>
          <td data-label="Industry / Niche"><div style="color:var(--muted);line-height:1.2;">${esc(d.industry)}</div></td>
          <td data-label="Attendees"><div class="pd-num">${esc(d.attendees)}</div></td>
          <td data-label="Exhibitors"><div class="pd-num">${esc(d.exhibitors)}</div></td>
          <td data-label="Month">${esc(d.month)}</td>
          <td data-label="Year">${esc(d.year)}</td>
          <td data-label="City">${esc(d.city)}</td>
          <td data-label="State"><span class="pd-pill">${esc(String(d.state || '').toUpperCase())}</span></td>
          <td data-label="Details">
            <a class="pd-detailslink" href="${esc(href)}"
              ${target ? `target="${target}"` : ''} ${rel ? `rel="${rel}"` : ''} ${ariaDisabled}
              aria-label="${esc(seoText)}">
              Explore
            </a>
            <span class="pd-visually-hidden">${esc(seoText)}</span>
          </td>
        </tr>
      `;
    }

    els.tbody.innerHTML = html;

    if (els.matchCount) els.matchCount.textContent = total.toLocaleString();
    if (els.countMobile) els.countMobile.textContent = total.toLocaleString();
    if (els.showingCount) els.showingCount.textContent = (end - start).toLocaleString();

    const has = total > 0;
    els.empty.style.display = has ? 'none' : 'block';
    els.tableArea.style.display = has ? 'block' : 'none';

    const prevDisabled = state.page <= 1;
    const nextDisabled = state.page >= totalPages;

    setPagerDisabled(els.prevBtn, prevDisabled);
    setPagerDisabled(els.nextBtn, nextDisabled);
    setPagerDisabled(els.prevBtn2, prevDisabled);
    setPagerDisabled(els.nextBtn2, nextDisabled);
  }

  function apply() {
    readControlsIntoState();
    computeFiltered();
    renderPage();
  }

  function resetAll() {
    els.q.value = '';
    els.fIndustry.value = '';
    els.fMonth.value = '';
    els.fCity.value = '';
    els.fState.value = '';
    els.fAtt.value = '';
    state.page = 1;
    apply();
  }

  function setupMobileFilters() {
    if (!els.mobileFiltersHost) return;

    els.mobileFiltersHost.innerHTML = '';
    const desktop = document.querySelector('.pd-filtersbar');
    if (!desktop) return;

    // clone just the grid (fields) into the mobile sheet
    const grid = desktop.querySelector('.pd-filtersgrid');
    if (!grid) return;

    const clone = grid.cloneNode(true);

    // rename ids inside clone so mobile can have its own controls
    const idMap = {
      pd_q: 'pd_q_m',
      pd_fIndustry: 'pd_fIndustry_m',
      pd_fMonth: 'pd_fMonth_m',
      pd_fCity: 'pd_fCity_m',
      pd_fState: 'pd_fState_m',
      pd_fAttendees: 'pd_fAttendees_m',
    };
    Object.entries(idMap).forEach(([from, to]) => {
      const el = clone.querySelector('#' + from);
      if (el) el.id = to;
    });

    // Mobile action buttons
    const actions = document.createElement('div');
    actions.style.display = 'flex';
    actions.style.gap = '10px';
    actions.style.marginTop = '12px';

    const applyBtn = document.createElement('button');
    applyBtn.className = 'pd-btn primary';
    applyBtn.type = 'button';
    applyBtn.textContent = 'Apply';

    const resetBtn = document.createElement('button');
    resetBtn.className = 'pd-btn';
    resetBtn.type = 'button';
    resetBtn.textContent = 'Reset';

    actions.appendChild(applyBtn);
    actions.appendChild(resetBtn);

    els.mobileFiltersHost.appendChild(clone);
    els.mobileFiltersHost.appendChild(actions);

    // Sync values
    const q_m = $('pd_q_m');
    const ind_m = $('pd_fIndustry_m');
    const mon_m = $('pd_fMonth_m');
    const city_m = $('pd_fCity_m');
    const st_m = $('pd_fState_m');
    const att_m = $('pd_fAttendees_m');

    if (q_m) q_m.value = els.q.value;
    if (ind_m) ind_m.value = els.fIndustry.value;
    if (mon_m) mon_m.value = els.fMonth.value;
    if (city_m) city_m.value = els.fCity.value;
    if (st_m) st_m.value = els.fState.value;
    if (att_m) att_m.value = els.fAtt.value;

    applyBtn.addEventListener('click', () => {
      els.q.value = q_m ? q_m.value : '';
      els.fIndustry.value = ind_m ? ind_m.value : '';
      els.fMonth.value = mon_m ? mon_m.value : '';
      els.fCity.value = city_m ? city_m.value : '';
      els.fState.value = st_m ? st_m.value : '';
      els.fAtt.value = att_m ? att_m.value : '';
      state.page = 1;
      apply();
      closeSheet();
    });

    resetBtn.addEventListener('click', () => {
      resetAll();
      if (q_m) q_m.value = '';
      if (ind_m) ind_m.value = '';
      if (mon_m) mon_m.value = '';
      if (city_m) city_m.value = '';
      if (st_m) st_m.value = '';
      if (att_m) att_m.value = '';
    });
  }

  function openSheet() {
    if (els.overlay) els.overlay.style.display = 'block';
    if (els.sheet) els.sheet.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeSheet() {
    if (els.overlay) els.overlay.style.display = 'none';
    if (els.sheet) els.sheet.classList.remove('open');
    document.body.style.overflow = '';
  }

  function wire() {
    if (els.totalCount) els.totalCount.textContent = (DATA.length || 0).toLocaleString();

    initDropdowns();
    state.page = 1;
    readControlsIntoState();
    computeFiltered();
    renderPage();

    if (els.applyBtn) els.applyBtn.addEventListener('click', () => { state.page = 1; apply(); });
    if (els.resetBtn) els.resetBtn.addEventListener('click', resetAll);
    if (els.resetBtnMobile) els.resetBtnMobile.addEventListener('click', resetAll);

    els.q.addEventListener('input', () => { state.page = 1; apply(); });
    [els.fIndustry, els.fMonth, els.fCity, els.fState, els.fAtt].forEach(sel => {
      sel.addEventListener('change', () => { state.page = 1; apply(); });
    });

    els.pageSize.addEventListener('change', () => {
      state.pageSize = parseInt(els.pageSize.value, 10) || 25;
      state.page = 1;
      renderPage();
    });

    const prev = () => { state.page -= 1; renderPage(); };
    const next = () => { state.page += 1; renderPage(); };

    if (els.prevBtn) els.prevBtn.addEventListener('click', prev);
    if (els.nextBtn) els.nextBtn.addEventListener('click', next);
    if (els.prevBtn2) els.prevBtn2.addEventListener('click', prev);
    if (els.nextBtn2) els.nextBtn2.addEventListener('click', next);

    if (els.openFiltersBtn) els.openFiltersBtn.addEventListener('click', () => { setupMobileFilters(); openSheet(); });
    if (els.closeFiltersBtn) els.closeFiltersBtn.addEventListener('click', closeSheet);
    if (els.overlay) els.overlay.addEventListener('click', closeSheet);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }
})();
